import { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import find from 'lodash/find'
import moment from 'moment'
import get from 'lodash/get'
import each from 'lodash/each'
import isEmpty from 'lodash/isEmpty'
import store from 'store2'
import { FormattedMessage } from 'react-intl'

import API from '../../api'
import ItineraryPopup from '../popups/ItineraryPopup'
import Select from 'react-select'
import PlaceholderPricing from './PlaceholderPricing'
import PricingRow from './PricingRow'
import DateFormat from '../helpers/DateFormat'
import TravelDatepicker from '../helpers/TravelDatepicker'
import InlineMultiselect from '../helpers/InlineMultiselect'
import { setDepartureDate } from '../../actions/dive-operator-actions'
import { trackEcommerce } from '../../gtm'
import { convertCurrency } from '../helpers/PriceConverter'
import { generateMonthPicker, parseQuery } from '../../utils'
import GuestPicker from '../forms/GuestPicker'
import { autosuggestStyles } from '../search/FiltersLa'

let controller
let signal

class LiveaboardPricing extends Component {
  constructor(props) {
    super(props)
    let date = moment().add(1, 'M').format('YYYY-MM-DD')
    if(store('date')) {
      date = store('date')[0]
    } else if(store('departure_date') && typeof store('departure_date') === 'object') {
      date = store('departure_date').from
    }

    const queryParams = parseQuery() || {}
    const roomParams = store('roomParams')

    if(queryParams.trip_date) {
      date = queryParams.trip_date
    }

    let filterObject = {
      from: moment(date).startOf('M').format('YYYY-MM-DD'),
    }

    if(queryParams.itinerary_id) {
      filterObject = {
        id: 'all',
      }
    }

    const selectedMonthItem = find(this.monthes, filterObject)

    this.state = {
      params: {
        page: 1,
        departure_date: date,
        page_size: 4,
        itinerary: queryParams.itinerary_id,
        is_promotion: false,
        is_available: false,
      },
      departure_date_month: selectedMonthItem,
      loading: true,
      firstLoading: true,
      revert: false,
      products: [],
      itineraries: [],
      groupedProducts: [],
      insurances: [],
      totalGuests: get(roomParams, 'totalGuests'),
      duration: props.itinerariesLength.map((item) => {
        return {
          id: item,
          checked: false,
          title: <FormattedMessage id='night_qty' values={
            { qty: item }
          } defaultMessage='{qty, plural, one {# night} other {# nights}}' />,
        }
      }),
    }
  }

  monthes = generateMonthPicker(this.props.monthsAmountWithProducts, true)

  getTrips() {
    this.setState({
      loading: true,
    })

    if(controller !== undefined) {
      // Cancel the previous request
      controller.abort()
    }

    if('AbortController' in window) {
      controller = new window.AbortController()
      signal = controller.signal
    }

    const departureMonth = get(this.state.departure_date_month, 'id')

    let filters = {
      ...this.state.params,
      departure_date: undefined,
    }

    if(this.state.departureDateLess) {
      filters.departure_date_less_then = this.state.params.departure_date
    } else {
      filters.departure_date = this.state.params.departure_date
    }

    this.props.dispatch(setDepartureDate(this.state.params.departure_date))

    if(departureMonth === 'available' || departureMonth === 'all' || this.state.params.is_available) {
      filters.page_size = 1000
    }

    API(`shop/${this.props.slug}/trips/`, signal).get(filters).then((trips) => {
      if(this.state.departureDateLess) {
        trips.results.reverse()
      }

      let groupedProducts = {}
      let gtmProducts = []
      let i = 1

      each(trips.results, (trip) => {
        if(find(trip.tags, { title: 'Sale' })) {
          trip.isSale = true
        }

        let month = moment(trip.startDate).month()
        let year = moment(trip.startDate).year()

        trip.iterator = i
        if(!groupedProducts[year + '_' + month]) {
          groupedProducts[year + '_' + month] = []
        }
        i++
        groupedProducts[year + '_' + month].push(trip)

        gtmProducts.push({
          name: trip.title || trip.itinerary.title,
          id: trip.id,
          price: Math.round(convertCurrency(trip.price, this.props.currency)),
          brand: this.props.title,
          category: 'Liveaboard',
          quantity: 1,
        })
      })

      trackEcommerce('product_view', {
        actionField: {
          list: 'Liveaboard product',
        },
        products: gtmProducts,
      })

      this.setState({
        groupedProducts,
        products: trips.results,
        previous: trips.previous,
        next: trips.next,
        totalTrips: trips.count,
        loading: false,
        firstLoading: false,
      })
    }).catch((e) => console.log('e', e))
  }

  getInsurances() {
    if(!this.props.includeFreeDiveInsurance) { return }
    API(`booking/insurances/`).get().then((insurances) => {
      this.setState({
        insurances,
      })
    })
  }

  componentDidMount() {
    this.getTrips()
    this.getItineraries()
    this.getInsurances()
  }

  getItineraries() {
    API(`shop/${window.shop.slug}/itineraries/`).get({
      kind: 10,
    }).then((itineraries) => {
      const queryParams = parseQuery() || {}
      itineraries.results.forEach(itinerary => {
        itinerary.checked = false
        if(queryParams.itinerary_id) {
          if(typeof queryParams.itinerary_id === 'string') {
            if(itinerary.id === +queryParams.itinerary_id) {
              itinerary.checked = true
            }
          } else {
            if(queryParams.itinerary_id.indexOf(itinerary.id.toString()) !== -1) {
              itinerary.checked = true
            }
          }
        }
      })
      this.setState({
        itineraries: itineraries.results,
      })
    })
  }

  onPageChange = (next) => {
    let page; let departureDateLess = this.state.departureDateLess

    if(this.state.departureDateLess) {
      page = next ? this.state.params.page - 1 : this.state.params.page + 1
    } else {
      page = next ? this.state.params.page + 1 : this.state.params.page - 1
    }
    if(page < 1) {
      page = 1

      if(!this.state.previous && this.checkPreviousTrips()) {
        departureDateLess = !departureDateLess
      }
    }

    this.setState({
      params: {
        ...this.state.params,
        page,
      },
      departureDateLess,
    }, this.getTrips)
  }

  checkPreviousTrips = () => {
    return moment(this.state.params.departure_date).startOf('month') > moment().startOf('month')
  }

  triggerCheckboxes = (name, val) => {
    this.setState({
      params: {
        ...this.state.params,
        [name]: val,
      },
    }, this.getTrips)
  }

  updateMonth(selectedOption) {
    if(controller !== undefined) {
      // Cancel the previous request
      controller.abort()
    }
    this.setState({
      params: {
        ...this.state.params,
        departure_date: selectedOption.from,
        page: 1,
      },
      departure_date_month: selectedOption,
      departureDateLess: false,
    }, () => {
      store('departure_date', selectedOption)
      store('date', [selectedOption.from, selectedOption.to])
      this.getTrips()
    })
  }

  handleGuestsChange = ({ totalGuests }) => {
    this.setState({
      totalGuests,
    })
  }

  updateFilters(item, value) {
    controller.abort()
    this.setState({
      params: {
        ...this.state.params,
        [item]: value,
        page: 1,
      },
    }, () => {
      this.getTrips()
    })
  }

  datePickerCallback = (date) => {
    if(!date.dateFrom) {
      store.remove('departure_date')
      store.remove('date')
      return this.updateMonth(this.monthes[1])
    }

    let selectedDate = find(this.monthes, {
      from: moment(date.dateFrom).startOf('M').format('YYYY-MM-DD'),
    })

    if(!selectedDate) {
      selectedDate = {}
    }

    let clonedDate = { ...selectedDate }

    clonedDate.from = date.dateFrom

    this.updateMonth(clonedDate)
  }

  render() {
    return (
      <div className={`la-pricing-table${this.state.loading ? ' loading' : ''}`}>
        <ItineraryPopup />
        <div promotion-tooltip='promotion-tooltip'>
          <div className='tr thead'>
            <div className='pricing-filters'>
              <div className='pricing-filters__block'>
                <label className='checkbox-wrap'>
                  <input type='checkbox' value={this.state.params.is_available} onClick={(e) => this.triggerCheckboxes('is_available', e.target.checked)} />
                  <span className='checkbox-area' />
                  <p><FormattedMessage id='pricing.all_available_trips' defaultMessage='All available trips' /></p>
                </label>
                <label className='checkbox-wrap'>
                  <input type='checkbox' value={this.state.params.is_promotion} onClick={(e) => this.triggerCheckboxes('is_promotion', e.target.checked)} />
                  <span className='checkbox-area' />
                  <p><FormattedMessage id='pricing.only_special_deals' defaultMessage='Only special deals' /></p>
                </label>
              </div>
              <div className='pricing-filters__block'>
                <div className='pricing-filters__field date-dropdown'>
                  <i className='font-icons field-icon calendar-icon' />
                  <Select
                    onChange={(selectedOption) => this.updateMonth(selectedOption)}
                    value={this.state.departure_date_month}
                    options={this.monthes}
                    styles={autosuggestStyles}
                    isSearchable={false}
                    valueKey='id'
                    className='select-container'
                    classNamePrefix='select-container' />
                </div>
                <div className='pricing-filters__field'>
                  <GuestPicker className='la-guest-picker' hideError showIcon isLiveaboard noStudentsPackages onSelect={this.handleGuestsChange} />
                </div>
              </div>
              {/* <CurrencyList /> */}
            </div>
            <div className='td td-date content-center'>
              <div className='multi-select white'>
                <span onClick={() => document.getElementById('dp-pricing').click()}>
                  <FormattedMessage id='start_date' defaultMessage='Start date' /></span>
                <TravelDatepicker id='dp-pricing'
                  dateFrom={this.state.from}
                  callback={this.datePickerCallback} />
                {/* <input id='dp-pricing' travel-datepicker='travel-datepicker' ng-model='operator.from' callback='operator.setSelectedItem(null)' /> */}
              </div>
            </div>
            <div className='td td-itinerary-information'>
              <div className='td-itinerary content-left'>
                { console.log(this.state.params) }
                <InlineMultiselect variants={this.state.itineraries} onSelect={(items) => this.updateFilters('itinerary', items)} title={<FormattedMessage id='itinerary' defaultMessage='Itinerary' />} />
              </div>
              <div className='td-duration content-left'>
                <InlineMultiselect variants={this.state.duration} onSelect={(items) => this.updateFilters('duration', items)} title={<FormattedMessage id='duration' defaultMessage='Duration' />} />
              </div>
            </div>
            <div className='td td-price content-right'>
              <span><FormattedMessage id='price_per_trip_person' defaultMessage='Price per trip / person' /></span>
            </div>
            <div className='td td-actions'>
                        &nbsp;
            </div>
          </div>
          <div>
            { this.state.loading
              ? (<Fragment>
                {
                  [...new Array(4)].map((_, i) => {
                    return (<PlaceholderPricing key={i} />)
                  })
                }
              </Fragment>)
              : isEmpty(this.state.groupedProducts)
                ? (<div className='no-products'>
                  <FormattedMessage id='no_trips_match_criteria' defaultMessage='No trips match your criteria' />
                </div>)
                : (Object.keys(this.state.groupedProducts).map((key) => {
                  return (
                    <div itemProp='offers' key={key} itemScope='itemscope' itemType='http://schema.org/Offer' className='month-group'>
                      { get(this.state.departure_date_month, 'id') === 'all' || this.state.params.is_available ? (
                        <div className='group-title'>
                          <DateFormat date={this.state.groupedProducts[key][0].startDate} format='MMMM YYYY' />
                        </div>
                      ) : '' }
                      {
                        this.state.groupedProducts[key].map((product) => {
                          return (<PricingRow
                            product={product}
                            key={product.id}
                            background={this.props.background}
                            currency={this.props.currency}
                            shopSlug={this.props.slug}
                            countrySlug={this.props.countrySlug}
                            totalGuests={this.state.totalGuests}
                            insurance={this.state.insurances[0]}
                          />)
                        })
                      }
                    </div>
                  )
                }))
            }
          </div>
        </div>
        { get(this.state.departure_date_month, 'id') !== 'all' ? (
          <div className='next-prev-btns-wrapper'>
            <div className='btns-wrap'>
              {
                this.state.departureDateLess && this.state.next || !this.state.departureDateLess && (this.state.previous || this.checkPreviousTrips())
                  ? (<div onClick={() => this.onPageChange(false)} className='paging-btn prev'>
                    <i className='font-icons left-arrow-icon' />
                    <span className='visible-xs' ><FormattedMessage id='previous' defaultMessage='Previous' /></span>
                    <span className='hidden-xs' ><FormattedMessage id='previous_4' defaultMessage='Previous 4 trips' /></span>
                  </div>) : ''
              }
              {
                this.state.departureDateLess || !this.state.departureDateLess && this.state.next
                  ? (<div onClick={() => this.onPageChange(true)} className='paging-btn next'>
                    <span className='visible-xs'><FormattedMessage id='next' defaultMessage='Next' /></span>
                    <span className='hidden-xs'><FormattedMessage id='next_4' defaultMessage='Next 4 trips' /></span>
                    <i className='font-icons right-arrow-icon' />
                  </div>) : ''
              }
            </div>
          </div>
        ) : ''}
      </div>
    )
  }
}

export default connect(
  state => ({
    date: state.departureDate,
  })
)(LiveaboardPricing)
